import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import globalState from '~/state/global';
import { App } from '~/app/App';
import { BUILD_VERSION } from '~/lib/environment';
import '~/styles/tailwind.css';

// index.html's <title> must stay this prefix without the version, or the tab name changes as the bundle boots.
document.title = `Back At You Toolbox : v${BUILD_VERSION}`;

// The shell toggles `theme-dark` on <html>; the toasts follow it.
const useIsDark = () => {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains('theme-dark'),
  );

  useEffect(() => {
    const update = () => setIsDark(document.documentElement.classList.contains('theme-dark'));
    const observer = new MutationObserver(update);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return isDark;
};

// Toasts sit at z-60, above modals (DESIGN.md 10.2); the library's own z-index is overridden with `!`.
const ThemedToastContainer = () => (
  <ToastContainer theme={useIsDark() ? 'dark' : 'light'} className="z-60!" />
);

// A data router, so `useBlocker` (hooks/useUnsavedGuard.ts) works. App declares its own <Routes>
// under this one splat route.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <>
        <App />
        <ThemedToastContainer />
      </>
    ),
  },
]);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={globalState.store}>
    <RouterProvider router={router} />
  </Provider>,
);
